<template>
  <div>
    <h1> Welcome to Start page </h1>
  </div>
</template>
  